import type { BoundActions, HookFunction } from 'react-sweet-state';
import { createStore, createHook } from 'react-sweet-state';
import type { LoomVideo } from '@loomhq/record-sdk';

type LoomInsertUrlStateType = {
	/**
	 * Loom recorder SDK return object to be passed to full page editor
	 */
	fullPageEditorLoomUrl: undefined | LoomVideo;
	/**
	 * Loom recorder SDK return object to be passed to page comment editor
	 */
	pageCommentEditorLoomUrl: undefined | LoomVideo;
	/**
	 * Loom recorder SDK return object to be passed to inline comment editor
	 */
	inlineCommentEditorLoomUrl: undefined | LoomVideo;
};

type LoomInsertUrlActionType = {
	updateFullPageEditorLoomUrl: (
		video: LoomVideo | undefined,
	) => ({ setState }: { setState: (state: Partial<LoomInsertUrlStateType>) => void }) => void;
	updatePageCommentEditorLoomUrl: (
		video: LoomVideo | undefined,
	) => ({ setState }: { setState: (state: Partial<LoomInsertUrlStateType>) => void }) => void;
};

const Store = createStore<LoomInsertUrlStateType, LoomInsertUrlActionType>({
	initialState: {
		fullPageEditorLoomUrl: undefined,
		pageCommentEditorLoomUrl: undefined,
		inlineCommentEditorLoomUrl: undefined,
	},
	actions: {
		updateFullPageEditorLoomUrl:
			(video) =>
			({ setState }) => {
				setState({
					fullPageEditorLoomUrl: video,
				});
			},
		updatePageCommentEditorLoomUrl:
			(video) =>
			({ setState }) => {
				setState({
					pageCommentEditorLoomUrl: video,
				});
			},
	},
	name: 'loomUrlToInsert',
});

export const useLoomInsertUrlState: HookFunction<
	LoomInsertUrlStateType,
	BoundActions<LoomInsertUrlStateType, LoomInsertUrlActionType>,
	void
> = createHook(Store);
export const useLoomInsertUrlActions = (): BoundActions<
	LoomInsertUrlStateType,
	LoomInsertUrlActionType
> => useLoomInsertUrlState()[1];
